module.exports = __webpack_public_path__ + "img/Richardson.6634f87e.jpg";